import { Component } from 'react';
import { Col, Row, Card, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';

class DamagedBarcodeSubmissionsSearch extends Component {
  render() {
    const {
      searchValue,
      onSearch,
      onClear,
      onInputChange,
      onStatusChange,
      onScanDateFromChange,
      onScanDateToChange,
      status,
      scanDateFrom,
      scanDateTo,
      statuses,
      onCsvDownload
    } = this.props;

    return (
      <Card className="admin-search-filter">
        <Card.Body>
          <Row>
            <Col md={12}>
              <FormGroup>
                <FormControl
                  placeholder="Search by id, customer_number, user_id..."
                  value={searchValue}
                  onChange={onInputChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                Status
                <FormControl
                  as="select"
                  value={status}
                  onChange={onStatusChange}
                >
                  <option>All</option>
                  {statuses && statuses.map((statusOption, index) =>
                    <option key={index} value={statusOption}>{statusOption}</option>)}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                Scan date from
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={scanDateFrom}
                  onChange={onScanDateFromChange}
                  closeOnSelect
                  inputProps={{
                    placeholder: 'Request date from'
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                Scan date to
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={scanDateTo}
                  onChange={onScanDateToChange}
                  closeOnSelect
                  inputProps={{
                    placeholder: 'Request date to'
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={3} className="actions" style={{marginTop: '20px'}}>
              <Button
                className="red-ghost-btn"
                onClick={onSearch}
              >
                Search
              </Button>
              <Button
                className="red-ghost-btn"
                onClick={onClear}
              >
                Clear search
              </Button>
              <Button
                className="red-ghost-btn"
                onClick={onCsvDownload}
              >
                Download damaged barcodes
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default DamagedBarcodeSubmissionsSearch;
